import {Component,OnInit,OnDestroy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {environment} from '../../../environments/environment';
export interface ReservationTicket {
 company_name:string;company_type:string;user_id:number;reservation_id:string;
 date:string;time:string;status:string;name:string|null;num_people:number|null;
 salon_name:string|null;service:string|null;pick_up:boolean;
 actions:{edit:boolean;cancel:boolean;confirm:boolean};
}
@Component({
    selector: 'app-reservation-ticket', templateUrl: './reservation-ticket.component.html', styleUrls: ['./reservation-ticket.component.scss'],
    standalone: false
})
export class ReservationTicketComponent implements OnInit,OnDestroy {
 ticket:ReservationTicket|null=null;context?:{companyName:string;reservationId:string;language?:string};
 loading=false;error=false;action:'view'|'edit'|'cancel'|'confirm'='view';
 readonly languages=['tr','en','de','es','el'];
 private token='';private routeSubscription?:Subscription;private request?:Subscription;
 constructor(private route:ActivatedRoute,private http:HttpClient,public translate:TranslateService){}
 get language(){return this.translate.currentLang||'en';}
 get statusKey(){const status=this.ticket?.status;return ['canceled','cancelled'].includes(status||'')?'cancelled':status==='pending'?'pending':'confirmed';}
 ngOnInit(){
  this.translate.addLangs(this.languages);this.translate.setDefaultLang('en');
  const browser=typeof navigator==='undefined'?'en':navigator.language.split('-')[0];this.translate.use(this.languages.includes(browser)?browser:'en');
  this.routeSubscription=this.route.paramMap.subscribe(params=>{this.token=params.get('token')||'';this.load();});
 }
 load(){
  this.request?.unsubscribe();this.action='view';this.loading=true;this.error=false;this.ticket=null;this.context=undefined;
  if(!/^[A-Za-z0-9_-]{24}$/.test(this.token)){this.loading=false;this.error=true;return;}
  this.request=this.http.get<{data:ReservationTicket}>(`${environment.baseUrl}/api/v1/public/reservation-tickets/${encodeURIComponent(this.token)}`).subscribe({next:({data})=>{this.ticket=data;this.context={companyName:data.company_name,reservationId:data.reservation_id};this.loading=false;},error:()=>{this.loading=false;this.error=true;}});
 }
 choose(action:'edit'|'cancel'|'confirm'){if(this.ticket?.actions[action]){if(this.context)this.context.language=this.language;this.action=action;}}
 print(){window.print();}
 ngOnDestroy(){this.request?.unsubscribe();this.routeSubscription?.unsubscribe();}
}
